import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PREVIEW_LANGUAGES } from '../../constants/languages';

// Re-exported for the screens that still import it from here.
export { PREVIEW_LANGUAGES };

interface LanguageState {
    current: string;
    languages: string[];
}

// Get initial language from localStorage or default to 'en'
const getInitialLanguage = (): string => {
    const savedLanguage = localStorage.getItem('currentLanguage');
    if (savedLanguage && PREVIEW_LANGUAGES.some(lang => lang.code === savedLanguage)) {
        return savedLanguage;
    }
    return 'en';
};

const initialState: LanguageState = {
    current: getInitialLanguage(),
    languages: PREVIEW_LANGUAGES.map(lang => lang.code),
};

const languageSlice = createSlice({
    name: 'language',
    initialState,
    reducers: {
        setCurrentLanguage(state, action: PayloadAction<string>) {
            if (PREVIEW_LANGUAGES.some(lang => lang.code === action.payload)) {
                state.current = action.payload;
                localStorage.setItem('currentLanguage', action.payload);
            }
        },
        setSupportedLanguages(state, action: PayloadAction<string[]>) {
            state.languages = action.payload.filter(
                code => PREVIEW_LANGUAGES.some(lang => lang.code === code)
            );
        }
    },
});

export const { setCurrentLanguage, setSupportedLanguages } = languageSlice.actions;
export default languageSlice.reducer;
